import {addAuthToAxiosOpts} from '../config/queryopts'
import {useQueryWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import PropTypes from "prop-types";


export const FlashAlertDetailsFetcher = (accessToken, uid = null) => {
  const uri = (uid) ? `/${uid}` : '';
  return axios.get(`${apiUrlInternal}/flash_alert${uri}`, addAuthToAxiosOpts(accessToken, {})).then(res => res.data);
}

export const useFlashAlertDetailsQuery = (uid = null, fetcher = FlashAlertDetailsFetcher) => {
  return useQueryWithAuthentication(['flashalert-details', uid],
    (accessToken) => fetcher(accessToken, uid))
}

useFlashAlertDetailsQuery.propTypes = {
  uid: PropTypes.string.isRequired
};
